import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeFirebaseData } from './firebase/initFirebase';
import { Toaster } from 'react-hot-toast';
import { QueryProvider } from './contexts/QueryProvider';

// Initialize Firebase data
initializeFirebaseData().catch(console.error);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryProvider>
      <Toaster position="bottom-right" />
      <App />
    </QueryProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
